export default __webpack_public_path__ + "static/media/Class-9-State-English.5df773b2.pdf";